import * as routes from 'api';

import * as timeOffActions from 'actions/timeOff';

import * as ptoPolicySelectors from 'selectors/ptoPolicy';

import { moment } from 'util/dateTime';
import { toI18n } from 'util/i18n';
import * as reduxUtil from 'util/redux';
import { browserHistory } from 'util/router';

export const actionTypes = {
  FETCH_PTO_POLICY_REQUEST: 'PTO_POLICY/FETCH_PTO_POLICY_REQUEST',
  FETCH_PTO_POLICY_SUCCESS: 'PTO_POLICY/FETCH_PTO_POLICY_SUCCESS',
  FETCH_PTO_POLICY_FAILURE: 'PTO_POLICY/FETCH_PTO_POLICY_FAILURE',
  DELETE_PTO_POLICY_REQUEST: 'PTO_POLICY/DELETE_PTO_POLICY_REQUEST',
  DELETE_PTO_POLICY_SUCCESS: 'PTO_POLICY/DELETE_PTO_POLICY_SUCCESS',
  DELETE_PTO_POLICY_FAILURE: 'PTO_POLICY/DELETE_PTO_POLICY_FAILURE',
};

export const fetchPTOPolicy = (id, force = false) =>
  reduxUtil.createAsyncGetAction(
    routes.ptoPolicyRoute(id),
    [
      {
        type: actionTypes.FETCH_PTO_POLICY_REQUEST,
        meta: { requestId: `policy${id}` },
      },
      {
        type: actionTypes.FETCH_PTO_POLICY_SUCCESS,
        meta: { requestId: `policy${id}` },
      },
      {
        type: actionTypes.FETCH_PTO_POLICY_FAILURE,
        meta: { requestId: `policy${id}` },
      },
    ],
    {
      bailout: state =>
        !force &&
        ptoPolicySelectors.getBailoutFetchPolicy(state, { policyId: id }),
    }
  );

export const deletePolicy = id => dispatch => {
  const meta = { requestId: `deletePolicy${id}`, id };

  return dispatch(
    reduxUtil.withAlerts(
      reduxUtil.createAsyncDeleteAction(routes.ptoPolicyRoute(id), [
        { type: actionTypes.DELETE_PTO_POLICY_REQUEST, meta },
        { type: actionTypes.DELETE_PTO_POLICY_SUCCESS, meta },
        { type: actionTypes.DELETE_PTO_POLICY_FAILURE, meta },
      ]),
      {
        success: toI18n('pto_policies.delete_success'),
        onSuccess: () => {
          // need to reload the jobs with the updated
          // policies categories after deleting policy
          // fetchTimeOffs will update jobs as needed.
          dispatch(
            timeOffActions.fetchTimeOffs({
              month: moment().format('MM-YYYY'),
              status: 'all',
              includeJobs: true,
            })
          );
          browserHistory.push('/time_offs');
        },
      }
    )
  );
};
